import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import Video from 'components/Videos/Video';
import Loader from 'components/Loader/Loader';
import MoreCard from 'components/pages/CardPage/MoreCard';
import ErrorPage from 'components/pages/ErrorPage/ErrorPage';
import Page404 from 'components/pages/Page404/Page404';
import {
  ContentFragment,
  useCompactLazyQuery,
  useContentByIdLazyQuery,
} from 'generated/graphql';

import s from './CardPage.module.scss';

interface CardPageProps {
  verify: boolean;
  flowURL: string;
}

const CardPage = (props: CardPageProps) => {
  const { verify, flowURL } = props;

  const [
    fetchAdditionalContents,
    {
      data: additionalContentsData,
    },
  ] = useCompactLazyQuery();

  const [fetchContent,
    {
      data: contentData,
      loading: contentLoading,
      error: contentError,
    },
  ] = useContentByIdLazyQuery();

  const match = useRouteMatch<{ id: string }>();

  const { params: { id } } = match;

  const content = contentData?.point?.service?.content;
  const additionalContents = additionalContentsData?.point?.service?.contents;

  useEffect(() => {
    if (verify && id) {
      fetchContent({
        variables: {
          id,
        },
      });
      fetchAdditionalContents();
    }
  }, [id, verify]);

  if (contentError && contentError.message.indexOf('bad key') !== -1) {
    return <Page404 />;
  }

  if (contentError) {
    return <ErrorPage />;
  }

  if (contentLoading) {
    return <Loader />;
  }

  if (contentData && !contentData.point?.service.content) {
    return <Page404 />;
  }

  if (!verify) {
    window.location.href = flowURL;
  }

  return (
    <>
      <div className={s.wrapper}>
        {
                    content
                      ? (
                        <Video
                          content={content}
                          authorized={verify}
                          flowUrl={flowURL}
                        />
                      ) : <div />
                }
        <div className={s.title}>
          SEE MORE
        </div>
        <div className={s.moreWrapper}>
          {
                        additionalContents ? additionalContents.map((item: ContentFragment) => (
                          <MoreCard
                            key={item.id}
                            content={item}
                          />
                        )) : <></>
                    }
        </div>
      </div>

    </>
  );
};

export default CardPage;
